<lib-lang-droplist class="lang-switcher"></lib-lang-droplist>

<form [formGroup]="form" (ngSubmit)="handleLoginClick()">
  <div class="login-wrapper">
    <ng-container *ngIf="!redirecting; else redirectInfo">
      <h1 class="mb-5">{{ 'login.log_in' | transloco }}</h1>
      <div *ngIf="respState === 'success'" class="info success mb-5">
        {{ 'login.we_sent_you_email' | transloco: { email: form.controls.email.value } }}
      </div>
      <p *ngIf="respState === 'error'" class="info error mb-2">{{ 'login.something_went_wrong' | transloco }}</p>
      <p
        *ngIf="respState === 'expiredCode' || respState === 'link_depleted' || respState === 'link_inactive'"
        class="info error mb-5"
      >
        {{ 'login.expired_code' | transloco }}
      </p>
      <p class="info error mb-5" *ngIf="redirectionErrorToken">
        {{ 'login.failed_starting_survey' | transloco: { token: redirectionErrorToken } }}
      </p>
      <ng-container *ngIf="respState !== 'success'">
        <mat-form-field class="mb-3">
          <mat-label>{{ 'login.enter_email_label' | transloco }}</mat-label>
          <input [formControl]="form.controls.email" matInput type="text" autocomplete="email" />
        </mat-form-field>
        <p class="desc mb-5">{{ 'login.description' | transloco }}</p>
      </ng-container>

      <button *ngIf="respState === 'success'" class="btn btn-primary w-100" (click)="respState = 'none'">
        <span *ngIf="!loading; else spinner"> {{ 'login.done' | transloco }}</span>
      </button>
      <button
        [disabled]="form.invalid && form.touched"
        *ngIf="respState !== 'success'"
        class="btn btn-primary w-100"
        type="submit"
      >
        <span *ngIf="!loading; else spinner">{{ 'login.log_in' | transloco }}</span>
      </button>
    </ng-container>
  </div>
</form>
<ng-template #spinner>
  <div class="spinner-container p-absolute">
    <mat-spinner class="white" [diameter]="20"></mat-spinner>
  </div>
</ng-template>

<ng-template #redirectInfo>
  <div class="error-container">
    <h2>{{ 'login.redirecting' | transloco }}</h2>
    <div class="loading-container">
      <lib-loading-column-animation></lib-loading-column-animation>
    </div>
  </div>
</ng-template>
